(() => {
  function init(root) {
    const button = root.querySelector('[data-copy-email]');
    const address = root.querySelector('[data-contact-email]');
    const status = root.querySelector('[role="status"]');
    if (!button || button.dataset.ready) return;
    button.dataset.ready = 'true';
    let timer;
    button.addEventListener('click', async () => {
      try {
        if (!navigator.clipboard || !window.isSecureContext) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(address.textContent.trim());
        status.textContent = 'Email address copied';
      } catch {
        status.textContent = 'Copy unavailable. Please select the email address and copy it.';
      }
      status.hidden = false;
      clearTimeout(timer);
      timer = setTimeout(() => { status.hidden = true; }, 5000);
    });
  }
  const root = document.getElementById('norelva-share-win');
  if (root) init(root);
  document.addEventListener('shopify:section:load', event => {
    const loaded = event.target.querySelector('#norelva-share-win');
    if (loaded) init(loaded);
  });
})();
